import { Box } from "@mui/material";

const Spacer = () => <Box component="span" sx={{ width: 20 }} />;

export default Spacer;
